// extracted by mini-css-extract-plugin
export default {"p_content":"be7b6e70f1"};